import { ElementType } from "react";

import { PolymorphicProps } from "@bentolabs/kit/types";
import { cn } from "@bentolabs/kit/utils";

type Props<E extends ElementType> = PolymorphicProps<E, { className?: string }>;
export const Input = <E extends ElementType = "input">({
  className,
  ...props
}: Props<E>) => {
  return (
    <input
      className={cn(
        "bg-onyx placeholder:text-nobel/50 text-nobel border-nobel/15 flex w-full rounded-2xl border p-3.5 outline-hidden",
        className
      )}
      {...props}
    />
  );
};
